/* eslint-disable */
import * as Types from '../../../../../../../../models/schema';

import { AocFragmentDTO } from '../../../../../../../../graphql/models/fragments';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type GetAocVariablesDTO = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type GetAocDTO = (
  { __typename?: 'Query' }
  & { aoc: (
    { __typename?: 'Aoc' }
    & AocFragmentDTO
  ) }
);


export const GetAocDocumentDTO = gql`
    query getAoc($id: String!) {
  aoc(id: $id) {
    ...aocFragment
  }
}
    ${AocFragmentDTO}`;

/**
 * __useGetAoc__
 *
 * To run a query within a React component, call `useGetAoc` and pass it any options that fit your needs.
 * When your component renders, `useGetAoc` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAoc({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAoc(baseOptions: Apollo.QueryHookOptions<GetAocDTO, GetAocVariablesDTO>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAocDTO, GetAocVariablesDTO>(GetAocDocumentDTO, options);
      }
export function useGetAocLazyQueryDTO(baseOptions?: Apollo.LazyQueryHookOptions<GetAocDTO, GetAocVariablesDTO>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAocDTO, GetAocVariablesDTO>(GetAocDocumentDTO, options);
        }
export type GetAocHookResult = ReturnType<typeof useGetAoc>;
export type GetAocLazyQueryDTOHookResult = ReturnType<typeof useGetAocLazyQueryDTO>;
export type GetAocQueryResultDTO = Apollo.QueryResult<GetAocDTO, GetAocVariablesDTO>;